import React, { useState } from 'react';

const UserChoices = ({ onChoicesConfirm }) => {
  const [gender, setGender] = useState(null);
  const [height, setHeight] = useState('');

  const handleHeightChange = (e) => {
    const value = e.target.value;
    // Simple validation to ensure it's a number
    if (!isNaN(value)) {
      setHeight(value);
    }
  };

  const handleConfirm = () => {
    if (gender && height) {
      onChoicesConfirm({ gender, height: parseFloat(height) });
    } else {
      // You can add a more sophisticated error message here
      console.error('Please select a gender and enter your height.');
    }
  };

  return (
    <div className="flex flex-col items-center p-4 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Choose Your 3D Model</h2>
      <p className="text-gray-600 mb-6 text-center">Select the gender and enter your height to generate your custom model.</p>
      
      <div className="flex flex-col space-y-4 w-full max-w-xs">
        {/* Gender Selection */}
        <div className="flex gap-4 justify-center">
          <button
            onClick={() => setGender('male')}
            className={`font-bold py-2 px-6 rounded-lg transition-colors ${
              gender === 'male' ? 'bg-blue-600 text-white' : 'bg-blue-200 text-blue-800 hover:bg-blue-300'
            }`}
          >
            Male
          </button>
          <button
            onClick={() => setGender('female')}
            className={`font-bold py-2 px-6 rounded-lg transition-colors ${
              gender === 'female' ? 'bg-pink-600 text-white' : 'bg-pink-200 text-pink-800 hover:bg-pink-300'
            }`}
          >
            Female
          </button>
        </div>

        {/* Height Input */}
        <div className="flex flex-col items-center mt-4">
          <label htmlFor="height-input" className="text-gray-700 mb-2">
            Your Height (in meters):
          </label>
          <input
            id="height-input"
            type="number"
            value={height}
            onChange={handleHeightChange}
            placeholder="e.g., 1.68"
            step="0.01"
            className="w-full p-2 text-center text-gray-800 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
      
      {/* Confirm Button */}
      <button
        onClick={handleConfirm}
        disabled={!gender || !height}
        className="mt-6 w-full py-3 text-white font-bold bg-green-500 rounded-lg hover:bg-green-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Confirm and Generate
      </button>
    </div>
  );
};

export default UserChoices;
